import styled, { css } from 'styled-components';
import { GEL_GROUP_3_SCREEN_WIDTH_MIN, GEL_GROUP_3_SCREEN_WIDTH_MAX } from '@bbc/gel-foundations/breakpoints';
import { GEL_SPACING } from '@bbc/gel-foundations/spacings';
import { grid } from '@bbc/psammead-styles/detection';
var twoOfSixColumnsMaxWidthScaleable = "33.33%"; // (2 / 6) * 100 = 0.3333333333 = 33.33%

var fullWidthColumnsMaxScaleable = "100%"; // (12 / 12) * 100 = 100 = 100%

var halfWidthColumnsMaxScaleable = "50%";
var imageGridFallbackRadio = /*#__PURE__*/css(["@media (min-width:", ") and (max-width:", "){width:", ";}"], GEL_GROUP_3_SCREEN_WIDTH_MIN, GEL_GROUP_3_SCREEN_WIDTH_MAX, twoOfSixColumnsMaxWidthScaleable);
var imageGridFallbackTv = /*#__PURE__*/css(["@media (min-width:", "){width:", ";}"], GEL_GROUP_3_SCREEN_WIDTH_MIN, halfWidthColumnsMaxScaleable);
var imageGridRadio = /*#__PURE__*/css(["@media (min-width:", ") and (max-width:", "){grid-column:1 / span 2;}"], GEL_GROUP_3_SCREEN_WIDTH_MIN, GEL_GROUP_3_SCREEN_WIDTH_MAX);
var imageGridTv = /*#__PURE__*/css(["@media (min-width:", "){grid-column:1 / span 3;}"], GEL_GROUP_3_SCREEN_WIDTH_MIN);
var imageGridFallbackStyles = {
  radio: imageGridFallbackRadio,
  tv: imageGridFallbackTv
};
var imageGridStyles = {
  radio: imageGridRadio,
  tv: imageGridTv
};
var ImageGridItem = /*#__PURE__*/styled.div.withConfig({
  displayName: "ImageGridItem",
  componentId: "sc-1kuq4ca-0"
})(["vertical-align:top;display:inline-block;width:", ";padding:", " ", " 0 ", ";", " @media (min-width:", "){padding:0;}@supports (", "){width:initial;grid-column:1 / span 6;", "}"], fullWidthColumnsMaxScaleable, GEL_SPACING, GEL_SPACING, GEL_SPACING, function (_ref) {
  var bulletinType = _ref.bulletinType;
  return imageGridFallbackStyles[bulletinType];
}, GEL_GROUP_3_SCREEN_WIDTH_MIN, grid, function (_ref2) {
  var bulletinType = _ref2.bulletinType;
  return imageGridStyles[bulletinType];
});
export default ImageGridItem;